import {
  DASHBOARD_TEMPLATE_BOARDS,
  type DashboardTemplateKey,
} from "@salestrak/widgets";
import type { Color, IconName } from "@salestrak/ui";
import type { WidgetSeed } from "#app/widgets/dashboards/use-widget-view";

export type DashboardTemplate = {
  key: string;
  label: string;
  description: string;
  icon: IconName;
  color: Color;
  seeds: WidgetSeed[];
};

/**
 * Display copy for each template. The template BOARDS (seeds with their stable
 * `<templateKey>:<index>` widgetKeys already baked) live in
 * @salestrak/widgets — the same module the core API seeds a
 * new team/workflow dashboard's first read from — so a template's board cannot
 * drift from what the server persists. Seed ORDER is identity: never reorder
 * an existing template's seeds, only append (rule enforced at the data).
 */
const PRESENTATION: Record<
  DashboardTemplateKey,
  Pick<DashboardTemplate, "label" | "description" | "icon" | "color">
> = {
  "pipeline-overview-v2": {
    label: "Pipeline overview",
    description: "Track volume, attention items, and how Projects move stage to stage.",
    icon: "git-branch",
    color: "teal",
  },
  "team-performance-v2": {
    label: "Team performance",
    description: "Compare workload, activity, and Update results, with follow-up load up top.",
    icon: "users",
    color: "green",
  },
  "projects-activity": {
    label: "Projects & activity",
    description: "A Project table beside the live activity feed, with volume counts up top.",
    icon: "activity",
    color: "blue",
  },
};

export const DASHBOARD_TEMPLATES: DashboardTemplate[] = DASHBOARD_TEMPLATE_BOARDS.map(
  (board) => ({
    key: board.key,
    seeds: board.seeds,
    ...PRESENTATION[board.key],
  }),
);
